import './landing.css';
import React, { useState, useEffect, useLayoutEffect, useCallback, useRef } from 'react';
import SliderImgs from '../../Content/Landing';
import { Helmet } from 'react-helmet';

const AUTO_MS = 5200;

const Landing = () => {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1023);
    const [current, setCurrent] = useState(0);
    /** Índices de slides cuya imagen ya puede pedirse (hero visible + siguiente). */
    const [heroImgKeys, setHeroImgKeys] = useState(() => new Set([0]));
    const touchStartX = useRef(0);
    const timerRef = useRef(null);
    const heroImgInit = useRef(true);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 1023);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const resetAutoplay = useCallback(() => {
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setCurrent((c) => (c + 1) % SliderImgs.length);
        }, AUTO_MS);
    }, []);

    useEffect(() => {
        resetAutoplay();
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [resetAutoplay]);

    useLayoutEffect(() => {
        const n = SliderImgs.length;
        if (heroImgInit.current) {
            heroImgInit.current = false;
            setHeroImgKeys(new Set([0, (0 + 1) % n]));
            return;
        }
        setHeroImgKeys((prev) => {
            const next = new Set(prev);
            next.add(current);
            next.add((current + 1) % n);
            next.add((current - 1 + n) % n);
            return next;
        });
    }, [current]);

    const onPrev = () => {
        setCurrent((c) => (c - 1 + SliderImgs.length) % SliderImgs.length);
        resetAutoplay();
    };

    const onNext = () => {
        setCurrent((c) => (c + 1) % SliderImgs.length);
        resetAutoplay();
    };

    const openConsulta = () => {
        window.dispatchEvent(new Event('masini:openConsulta'));
    };

    const onTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const onTouchEnd = (e) => {
        const dx = e.changedTouches[0].clientX - touchStartX.current;
        if (Math.abs(dx) > 50) {
            if (dx < 0) onNext();
            else onPrev();
        }
    };

    return (
        <section
            className="hero Landing-Component"
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
        >
            <Helmet>
                <link
                    rel="preload"
                    href={isDesktop ? SliderImgs[0].DesktopImg : SliderImgs[0].MobileImg}
                    as="image"
                />
            </Helmet>

            <div className="hero-slides" aria-hidden="true">
                {SliderImgs.map((image, index) => {
                    const url = isDesktop ? image.DesktopImg : image.MobileImg;
                    const showImg = heroImgKeys.has(index);
                    return (
                        <div
                            key={index}
                            className={`hero-slide${index === current ? ' active' : ''}`}
                        >
                            {showImg ? (
                                <img
                                    className="hero-slide-img"
                                    src={url}
                                    alt=""
                                    decoding="async"
                                    loading={index === 0 ? 'eager' : 'lazy'}
                                />
                            ) : null}
                        </div>
                    );
                })}
            </div>

            <div className="hero-content">
                <div className="hero-stack">
                    <div className="hero-eyebrow-wrap">
                        <div className="hero-eyebrow">
                            <span>Estudio Jurídico · Buenos Aires</span>
                        </div>
                    </div>
                    <div className="hero-main">
                        <h1>
                            Defendemos lo<br />que más <em>te importa.</em>
                        </h1>
                        <p className="hero-sub">
                            Asesoramiento legal personalizado, con trato directo y estrategia desde el primer momento.
                        </p>
                        <button type="button" className="hero-btn" onClick={openConsulta}>
                            Solicitar consulta
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                <line x1="5" y1="12" x2="19" y2="12" />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default Landing;
